import '@/plugins/bootstrap-vue'

import App from './App'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import PortalVue from 'portal-vue'
Vue.use(PortalVue)
Vue.use(VueI18n)

import '@/assets/main.scss'

Vue.config.productionTip = false

const i18n = new VueI18n({ locale: 'es' })

const render = h => h('div', { attrs: { id: 'app' } }, [
  h(App)
])

new Vue({ render, i18n }).$mount('#app')



new Vue({
  render: h => h(App),
}).$mount('#app')
 